var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1412,
    height: 305,
    viewBox: "0 0 1412 305",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1411.34 1C941.221 113.331 471.103 113.331 1 1",
    stroke: "url(#paint0_linear_2475_735)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 304.248C471.117 191.917 941.234 191.917 1411.34 304.248",
    stroke: "url(#paint1_linear_2475_735)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2475_735",
    x1: 1,
    y1: 43.1244,
    x2: 1411.34,
    y2: 43.1243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201737,
    stopColor: "#3D0172"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763248,
    stopColor: "#2C015A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFCF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2475_735",
    x1: 1411.34,
    y1: 262.124,
    x2: 1,
    y2: 262.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201737,
    stopColor: "#3D0172"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763248,
    stopColor: "#2C015A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFCF8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.2c9260852a95bea8573b7ec107e3157f.svg";
export { ForwardRef as ReactComponent };